import styled from 'styled-components';
import { PathSliceIcon } from '../../../Icon/ChartIcon';
import { theme } from '../../../../styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 6px;
`;

export const Grid = styled.div<{ $shouldWrap?: boolean }>`
  display: grid;
  gap: 4px;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  ${({ $shouldWrap }) =>
    $shouldWrap &&
    `
    display: flex;
    flex-wrap: wrap;
  `};
`;

export const DropdownContainer = styled.div<{
  $isDropdownOpen: boolean;
}>`
  display: flex;
  width: fit-content;
  align-items: center;
  border-radius: 4px;
  border: 1px solid transparent;

  &:hover {
    background-color: ${theme.colors.blue500};
  }

  ${({ $isDropdownOpen }) =>
    $isDropdownOpen &&
    `
    background-color: ${theme.colors.blue500};
    border-color: ${theme.colors.mainBlue};  
  `};
`;

export const PathSliceIconImage = styled(PathSliceIcon)`
  min-width: 16px;
  color: ${theme.colors.mainBlue};
`;

export const GroupbyHint = styled.div`
  margin-bottom: 6px;
  font-size: 10px;
  font-weight: 500;
  user-select: none;
  color: ${theme.colors.secondary800};
`;

export const SingleValueLabel = styled.div<{
  $isVisible?: boolean;
}>`
  font-size: 12px;
  font-weight: 600;
  padding: 0 4px 0 8px;
  display: flex;
  align-items: center;
  column-gap: 4px;
  color: ${({ $isVisible }) =>
    $isVisible ? theme.colors.secondary600 : theme.colors.secondary400};
  cursor: pointer;
`;

export const GroupName = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BuilderInfoLabel = styled.div`
  font-size: 10px;
  font-weight: 400;
  color: ${theme.colors.secondary800};
`;

export const GroupItemIcon = styled.div<{ $color: string; $disabled: boolean }>`
  flex: 0 0 auto;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background-color: ${({ $color, $disabled }) =>
    $disabled ? 'currentColor' : $color};
`;
